import { Alert, Card, Layout, message } from 'antd'
import { Redirect } from 'react-router-dom'
import { useEffect, useState, cloneElement } from 'react'
import WeaverService from 'Services/WeaverService'
import './index.scss'

LandingPage = ({ children, error }) ->

  useEffect( ->
    if Weaver.Error.EXPIRED_SESSION_TOKEN is parseInt(location.hash?.slice(1))
      message.error('Your session has expired')
  , [])

  if WeaverService.isAuthenticated()
    <Redirect to="/" />
  else
    <Layout className="entry-container pattern grid-pattern">
      <div
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '5vh',
          zIndex:10000
        }}
      >
        <Card className="entry-form-container">
          <div className="entry-title">Weaver</div>
          <div className="entry-illustration"></div>
          <div className="weaver-info">
            Weaver helps you structure your information<br></br>in a user-friendly way.
          </div>

          { if error then <Alert message={error} type="error" /> }
          { children }
        </Card>
        <div className="entry-footer">
          <a href="https://weaverhq.com" target="_blank">Powered by weaverhq.com</a>
        </div>
      </div>
    </Layout>

export default LandingPage
